import length from "./length";

var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

export default function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return length(object);
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-geo/src/distance.js
// module id = ../../../../d3-geo/src/distance.js
// module chunks = 4